import config from '@/config/index';

/*
传参样例：
tag: {"dfcy":"平台公司","kcpt":"重大科技基础设施"}
organization: 三安光电
industrycategory: 智慧政务应用;智慧城市应用;智慧民生应用;智慧产业应用;传统基础设施赋能;中小企业赋能;数据中心;云边端;大数据平台;人工智能;区块链服务平台;数据交易;产业园区生态;共性支撑软件;科学仪器;中试服务生态;共享开源平台;基础安全能力;行业应用安全;新型安全服务平台;5G网络;千兆固网;卫星互联网;车联网;工业互联网;政务专网
nation: 中国
legalperson: 林志强
contacts: 林志强
mobile: 18635186578
registeredcapital: 407842
address: 湖北省荆州市荆州开发区东方大道131号
zipcode: 10000
province: 湖北省
district: 荆州市
attachment: [{"name":"1596607161244-机构协议.java"}]
logo: 1596607192877oy3bd4hhb5ApQBdeQmKzszvJ0BO4.jpg
scc: 91420000271752845A
orgdesc: 电子工业技术研究、咨询服务；电子产品生产、销售；超高亮度发光二极管(LED)应用产品系统工程的安装、调试、维修；经营本企业自产产品及技术的出口业务；经营本企业生产所需的原辅材料、仪器仪表、机械设备、零配件及技术的进口业务（国家限定公司经营和国家禁止进出口的商品及技术除外）；经营进料加工和“三来一补”业务。（法律法规规定必须办理审批许可才能从事的经营项目，必须在取得审批许可证明后方能营业）。
cloudProtocol: [{"name":"1596607262748-机构协议.java"}]
businessLicense: 1596607271316截屏2020-08-05 10.21.10.png
binduid: 11
checked: 1   // 1: 界面：创建机构页面，可以调修改接口进行修改; else: 界面：机构详情页面，可以调修改接口进行修改
*/
function addOrg() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/addorg`;
}

function modifyOrg() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/modifyorg`;
}

function getUserinfo(uid) {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/userinfo/${uid}`;
}

function getOrgDetail(orgid) {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/organization/${orgid}`;
}

/**
 * 根据社会信用代码获取机构信息
 * @param scc   社会信用代码
 * @param request
 * @GetMapping("/organizationbyscc/{scc}")
 */
function getOrgByScc(scc) {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/organizationbyscc/${scc}`;
}

/**
 * 申请加入某机构
 *
 * @param orgid         机构ID
 * @param apply_uid     申请加入机构的用户ID
 * @param department    部门
 * @param jobstation    职位
 * @param request
 * @PostMapping("/applyjoinorg")
 */
function applyJoinOrg() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/applyjoinorg`;
}

/**
 * 机构管理员获取某个正在申请加入的用户信息
 * @param apply_uid
 * @param request
 * @GetMapping("/getapplyorginfoofuser/{uid}")
 */
function getApplyOrgInfoOfUser(apply_uid) {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/getapplyorginfoofuser/${apply_uid}`;
}

/**
 * 机构管理员审核待加入的员工
 *
 * @param orgid         机构ID
 * @param apply_uid     申请加入机构的用户ID
 * @param department    部门
 * @param jobstation    职位
 * @param request
 * @PostMapping("/auditjoinorg")
 */
function auditJoinOrg() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/auditjoinorg`;
}

/**
 * 机构管理员获取所有员工
 *
 * @param orgid        机构ID
 * @param apply_org_checked  待审核状态 0-待审核  1-已审核 9-全部
 * @param page         当前第几页
 * @param limit        限制多少页
 * @param request
 * @GetMapping("/orguserlist")
 */
function getOrgUserList() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/orguserlist`;
}

export {
  addOrg,
  modifyOrg,
  getUserinfo,
  getOrgDetail,
  getOrgByScc,
  applyJoinOrg,
  getApplyOrgInfoOfUser,
  auditJoinOrg,
  getOrgUserList
};
